<div class="main">
  <div class="section">
    <div class="header">
      {{'ROLES_FUNCTIONALITIES.roleFunc' | translate}}
      <i class="material-icons" (click)="closeDialog();">clear</i>
    </div>
    <div class="rolesSection">

      <div class="container">
        <mat-checkbox (click)="selectAll()">Select All</mat-checkbox>
          <li class="rolesList" *ngFor="let item of roles; let i = index">
            <div *ngIf="!item.hidden">
              <img [hidden]='!item.functionalities' (click)='item.showHide=!item.showHide;' class="dropdown-icon" src="assets/icon-dropdown.svg" alt="">
              <mat-checkbox [(ngModel)]="item.checked" (change)='roleSelect(item);'>{{item.name}} </mat-checkbox>

              <li class="functionalitiesList" [hidden]='!item.showHide' *ngFor="let sub of item.functionalities; let ind = index">
                <mat-checkbox [(ngModel)]='sub.checked' (change)='functionSelect(item);' >{{sub.name}}</mat-checkbox>
              </li>
            </div>
          </li>
      </div>
    </div>
    <div class="bottom">
      <div class="submitButton" (click)="submit()">
        <div class="button">
          {{'ROLES_FUNCTIONALITIES.submitButton' | translate}}
        </div>
      </div>

    </div>
  </div>
</div>
